import { BriefcaseIcon } from '@/components/icons'
import { H1 } from '@/components/typography'
import { VacancyTag } from '@/components/vacancy-tag'
import { VacancyDetail } from '@/interfaces/vacancy'
import Block from '@/layouts/block'

const GeneralInfoTitle = ({
  title,
  publicationStatusId,
}: Pick<VacancyDetail, 'title' | 'publicationStatusId'>) => {
  return (
    <Block className="flex items-center flex-wrap gap-4 pt-4 md:pt-9 col-span-full">
      <BriefcaseIcon width="40" height="30" />
      {title && <H1>{title}</H1>}
      {publicationStatusId && (
        <VacancyTag publicationStatusId={publicationStatusId} />
      )}
    </Block>
  )
}

export default GeneralInfoTitle
